/**
 * Factor Submit API
 *
 * Convenience wrappers for submitting specific factor types.
 */

import type { OnboardingFlowResponse } from '@/features/onboarding/types/onboarding.types';
import { submitFactor } from './user-onboarding-api';

/**
 * Submit SMS OTP code
 */
export const submitSmsCode = (code: string): Promise<OnboardingFlowResponse> =>
  submitFactor({ otp_code: code });

/**
 * Submit password for enrollment
 */
export const submitPassword = (
  password: string
): Promise<OnboardingFlowResponse> => submitFactor({ password });

/**
 * Submit TOTP code for enrollment verification
 */
export const submitTotpCode = (code: string): Promise<OnboardingFlowResponse> =>
  submitFactor({ otp_code: code });

/**
 * Submit WhatsApp OTP code
 */
export const submitWhatsappCode = (
  code: string
): Promise<OnboardingFlowResponse> => submitFactor({ otp_code: code });

/**
 * Submit WebAuthn credential for enrollment
 */
export const submitWebauthn = (
  credential: unknown
): Promise<OnboardingFlowResponse> => submitFactor({ credential });
